"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvisibleSmartCaptcha = void 0;
const react_1 = __importStar(require("react"));
const useSmartCaptcha_1 = require("../hooks/useSmartCaptcha");
const InvisibleSmartCaptcha = (props) => {
    const containerRef = react_1.useRef(null);
    const { onChallengeHidden, onChallengeVisible, onSuccess, onNetworkError, language } = props, restProps = __rest(props, ["onChallengeHidden", "onChallengeVisible", "onSuccess", "onNetworkError", "language"]);
    const { render, destroy, execute, subscribe } = useSmartCaptcha_1.useSmartCaptcha(Object.assign(Object.assign({}, restProps), { hl: language, autoload: true, invisible: true }), containerRef);
    react_1.useEffect(() => {
        render();
        return destroy;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, restProps.hideShield, restProps.shieldPosition, restProps.sitekey, restProps.test]);
    react_1.useEffect(() => {
        if (restProps.visible) {
            execute();
        }
    }, [execute, restProps.visible]);
    react_1.useEffect(() => {
        if (!onChallengeVisible) {
            return;
        }
        return subscribe === null || subscribe === void 0 ? void 0 : subscribe('challenge-visible', onChallengeVisible);
    }, [onChallengeVisible, subscribe]);
    react_1.useEffect(() => {
        if (!onChallengeHidden) {
            return;
        }
        return subscribe === null || subscribe === void 0 ? void 0 : subscribe('challenge-hidden', onChallengeHidden);
    }, [onChallengeHidden, subscribe]);
    react_1.useEffect(() => {
        if (!onNetworkError) {
            return;
        }
        return subscribe === null || subscribe === void 0 ? void 0 : subscribe('network-error', onNetworkError);
    }, [onNetworkError, subscribe]);
    react_1.useEffect(() => {
        if (!onSuccess) {
            return;
        }
        return subscribe === null || subscribe === void 0 ? void 0 : subscribe('success', onSuccess);
    }, [onSuccess, subscribe]);
    return react_1.default.createElement("div", { ref: containerRef, className: "smart-captcha" });
};
exports.InvisibleSmartCaptcha = InvisibleSmartCaptcha;
